/// <amd-module name="Build/Run/Components/RunSummaryWorkItemsLinkComponent" />
import * as React from "react";

import { RunSummaryBaseLinkComponent } from "Build/Run/Components/RunSummaryBaseLinkComponent";

import * as Resources from "Build/Run/Resources";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { localeFormat } from "VSS/Core/Util/String";
import { Icon } from "VSSUI/Icon";
import { Observer } from "VSSUI/Observer";

export interface IRunSummaryWorkItemsLinkProps {
    traceabilityWorkItemsCount: IReadonlyObservableValue<number>;
    currentRunId: number;
    linkDescribedBy?: string;
}

const c_RunViewWorkItemsText = "RunViewWorkItems";
const c_WorkItemsHubDefaultRoute = "ms.vss-traceability-web.traceability-run-workitems-hub-default-route";
const c_WorkItemsThresholdValue = 50;

export class RunSummaryWorkItemsLink extends VssComponent<IRunSummaryWorkItemsLinkProps> {
    constructor(props: IRunSummaryWorkItemsLinkProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render() {

        return <Observer traceabilityWorkItemsCountData={this.props.traceabilityWorkItemsCount}>
            {
                (observerProps: { traceabilityWorkItemsCountData: number }) => {
                    const count = observerProps.traceabilityWorkItemsCountData;
                    const className = "text-ellipsis flex-row flex-baseline ";

                    if (!!count && count > 0) {

                        // For now, if the workitems count is greater than 50, we want to show 50+ text in the UI
                        var textToDisplay = "";
                        if (count > c_WorkItemsThresholdValue) {
                            textToDisplay = localeFormat(Resources.WorkItemsMoreThanThresholdFormat, c_WorkItemsThresholdValue.toString());
                        }
                        else {
                            textToDisplay = localeFormat(Resources.WorkItemsFormat, count.toString());
                        }

                        return <RunSummaryBaseLinkComponent
                            currentRunId={this.props.currentRunId}
                            linkClassName={className}
                            iconName="WorkItem"
                            routeId={c_WorkItemsHubDefaultRoute}
                            urlDisplayText={textToDisplay}
                            subtle={true}
                            telemetryProperties={{clickedOn: c_RunViewWorkItemsText}}
                            linkDescribedBy={this.props.linkDescribedBy} />
                    }
                    else {
                        return (
                            <span className="text-ellipsis secondary-text summary-line-non-link">
                                <Icon iconName="WorkItem" className="pipelines-icon-right-margin" />
                                {localeFormat(Resources.WorkItemsFormat, "0")}
                            </span>
                        );
                    }
                }
            }
        </Observer>
    }
}
